import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Ignore a browser-only structured-clone error emitted by some performance
// timing implementations. Keeping this in the compiled bundle avoids the
// inline script that previously weakened a strict Content Security Policy.
window.addEventListener("error", (event) => {
  if (
    event.error instanceof DOMException
    && event.error.name === "DataCloneError"
    && event.message?.includes("PerformanceServerTiming")
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true);

// Eagerly register the service worker so the app is installable as a PWA
// (Chrome's installability check requires a registered SW with a fetch
// handler + a valid manifest). The SW itself is safe — see
// /public/sw.js: only hashed /static/* bundle assets and /icons/* are
// cached; API, HTML, login, scanner and admin requests always go to the
// network. Registration is fire-and-forget; failure (e.g. unsupported
// browser, http:// dev origin) is silently ignored.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/", updateViaCache: "none" })
      .catch(() => { /* installability is best-effort */ });
  });

  // One-shot auto-reload when a fresh service worker takes control.
  // This guarantees that desktop tabs holding an older bundle pick up the
  // new build the next time they refresh — without affecting the very
  // first page load (sessionStorage flag prevents reload loops).
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    const k = "shelflife_sw_reloaded";
    if (sessionStorage.getItem(k)) return;
    sessionStorage.setItem(k, "1");
    window.location.reload();
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
